import {CollectionAbstraction} from "@/classes/abstractions/collection.abstraction";
import {IsInstance, ValidateNested} from "class-validator"
import {AccreditationRequestModel} from "@/classes/models/AccreditationRequest.model";

export class AccreditationRequestsCollection extends CollectionAbstraction {
  @IsInstance(AccreditationRequestModel)
  @ValidateNested()
  models;

  constructor(models = []) {
    super(models);
    this.models = [...models];
  }

  async getFake(length = 10) {
    const model = new AccreditationRequestModel();
    return await super.getFake(model, length);
  }
}
